export const isStripePaymentsTabVisible = ({ loading, status } = {}) => (
  loading === false && (status?.usable === true || status?.hasStripeEnabledPromoStore === true)
);
